import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { enqueueSnackbar } from '../../../../components/GlobalSnackbar/snackbarStore';
import { isSupabaseError } from '../../../../constants/supabaseErrors';
import { DocumentMinimalData } from '../../../../types';
import { keys as documentKeys } from '../../api/keys';
import { keys as topicKeys } from '../../../topics/api/keys';
import { useChangeDocumentsOfResource } from '../../hooks/useChangeDocumentsOfResource';

type Props = {
  subTopicId: string;
  onClose: () => void;
};

export default function useAddDocumentsModal(props: Props) {
  const queryClient = useQueryClient();
  const { uploadPendingFiles, saveDocumentChanges, isPending } = useChangeDocumentsOfResource();

  const [documents, setDocuments] = useState<DocumentMinimalData[]>([]);
  const [serverError, setServerError] = useState<string | null>(null);

  async function handleConfirm() {
    setServerError(null);

    if (documents.length === 0) {
      props.onClose();

      return;
    }

    try {
      const uploadedDocuments = await uploadPendingFiles(documents, { subjectId: props.subTopicId });

      await saveDocumentChanges([], uploadedDocuments, {
        sub_topic_id: props.subTopicId,
      });

      queryClient.invalidateQueries({ queryKey: documentKeys.documents });
      queryClient.invalidateQueries({ queryKey: [...topicKeys.all, 'activityTimeline'] });
      queryClient.invalidateQueries({ queryKey: topicKeys.subTopic(props.subTopicId) });

      enqueueSnackbar('Documents ajoutés.', 'success');
      props.onClose();
    } catch (errors: unknown) {
      if (isSupabaseError(errors)) {
        setServerError(errors.message);

        return;
      }

      setServerError('Une erreur est survenue.');
    }
  }

  return {
    documents,
    setDocuments,
    handleConfirm,
    serverError,
    isConfirmationPending: isPending,
  };
}
